import { useGlobalStore } from "@/store";
import theme from "@/theme";
import { Stack, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

export interface HereToHelpCardProps {
  title: string;
  description: string;
  button: {
    text: string;
    icon: React.ReactNode;
  };
}

export default function HereToHelpCard(props: HereToHelpCardProps) {
  const {
    title,
    description,
    button: { text, icon },
  } = props;

  const isRetailMember = useGlobalStore().state.currentUser.isRetailMember;
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <Stack
        sx={{
          border: `1.5px solid ${theme.palette.primary[800]}`,
          borderRadius: 2,
          overflow: "hidden",
        }}
        width="100%"
      >
        <Stack
          sx={{
            backgroundColor: theme.palette.primary[800],
            padding: 2,
          }}
        >
          <Stack
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            gap={1}
          >
            <Typography
              fontWeight={600}
              variant="h3"
              sx={{
                fontWeight: 600,
                fontSize: 16,
                color: "white",
                lineHeight: 1.5,
              }}
            >
              {title}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: 1.5,
                color: "white",
                whiteSpace: "pre-line",
              }}
            >
              {description}
            </Typography>
          </Stack>
        </Stack>

        <Stack
          role="button"
          aria-label={text}
          pt={1.875}
          pb={1.875}
          gap={1.25}
          flexDirection="row"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="center"
          onClick={() => {
            if (isRetailMember) {
              navigate("/home/get-medical-assistance/intercare");
            } else {
              navigate("/home/get-medical-assistance/prompt", {
                state: { from: location },
              });
            }
          }}
          sx={{
            cursor: "pointer",
            width: "100%",
            backgroundColor: theme.palette.common.white,
          }}
        >
          {icon}
          <Typography
            style={{
              textAlign: "center",
              fontSize: 15,
              fontWeight: 700,
              lineHeight: 1.25,
              color: theme.palette.primary[700],
            }}
          >
            {text}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
}
